import {toast} from 'react-toastify';
import SimpleForm from './simple';
import AuctionForm from './auction';
import SaleForm from './sale';
import PrePaymentForm from '../prepayment';
import {useFarm} from 'context/farmContext';

const EditOwnerForm = () => {
  const {farm} = useFarm();

  switch (farm?.type) {
    case 'simple':
      return <SimpleForm />;
    case 'auction':
      return <AuctionForm />;
    case 'sale':
      return <SaleForm />;
    case 'prepayment':
      return <PrePaymentForm />;
    default:
      toast.error('لطفا نوع آگهی را انتخاب کنید');
      return <></>;
  }
};

export default EditOwnerForm;
